import { SVGProps } from "react";

/**
 * Figma `arrow-left` icon (0 0 24 24).
 */
const ArrowLeft = ({
  width = 24,
  height = 24,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
      <g id="Arrow left">
      <path id="Vector" d="M14.8711 5.14061C15.1248 4.8869 15.5441 4.8869 15.7978 5.14061C16.0515 5.39431 16.0515 5.81367 15.7978 6.06736L10.5332 11.332C10.1653 11.7001 10.1652 12.298 10.5332 12.666L15.7978 17.9306C16.0515 18.1843 16.0515 18.6037 15.7978 18.8574L15.7968 18.8594C15.6676 18.9799 15.5022 19.0497 15.3349 19.0498C15.169 19.0498 15.0021 18.9884 14.8711 18.8574L9.60642 13.5928C8.73109 12.7173 8.73111 11.2807 9.60642 10.4053L14.8711 5.14061Z" fill="currentColor" stroke="currentColor" strokeWidth="0.1"/>
      <path id="Vector_2" opacity="0" d="M24 0H0V24H24V0Z" fill="currentColor"/>
      </g>
  </svg>
);

export default ArrowLeft;
